import BadgeBoxContainer from './BadgeBox.container';
import BadgeBox from './BadgeBox';
export default BadgeBoxContainer(BadgeBox);
